import React, { FC, memo } from 'react';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import { useSubmissionStatusOptions } from '@blocs.filter';
import { FilterData } from '../../../shared/types';

type Props = FilterData & { dataTestId?: string };

const SubmissionStatus: FC<Props> = ({ name, label, dataTestId }) => {
  const submissionStatusOptions = useSubmissionStatusOptions();

  return (
    <DropdownWithChildren
      withFormik
      withSelectAll
      isMultipleSelect
      name={name}
      toggleLabel={label}
      options={submissionStatusOptions}
      dataTestId={dataTestId}
    />
  );
};

export default memo(SubmissionStatus);
